import React, {createRef, useEffect} from 'react';
import ArticleWarehouseSelectProperties from "./ArticleWarehouseSelectProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import {useCommonContext} from "../../../contexts/CommonContext";
import {useStyles} from "./ArticleWarehouseSelect.style";
import clsx from "clsx";
import {useCommonStyles} from "../../../ui_components/common/CommonStyles.style";
import Loading from "../../../ui_components/PageLoading/Loading";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ArticleWarehouseSelectStore from "./ArticleWarehouseSelectStore";
import {Observer} from "mobx-react-lite";
import ArticleWarehouseElementRow from "./row/ArticleWarehouseElementRow";
import CancelIcon from '@mui/icons-material/Cancel';
import {Tooltip} from "@material-ui/core";
import ArticleWarehouse from "../../../entities/productOrder/article/ArticleWarehouse";

const ArticleWarehouseSelect: React.FC<ArticleWarehouseSelectProperties> = ({
                                                                            onChange,
                                                                            disabled,
                                                                            fullWidth = false,
                                                                            className = '',
                                                                            selected,
                                                                            label,
                                                                        }) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const menuRef = createRef<HTMLDivElement>();
    const inputRef = createRef<HTMLInputElement>();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new ArticleWarehouseSelectStore(commonContext, selected);
    const containerClasses = clsx(classes.select_container, className, fullWidth && commonClasses.fullWidth);

    useEffect(() => {
        const clickOutside = (event: any) => {
            if (menuRef && !menuRef.current?.contains(event.target)) {
                store.toggleSearchDialog(false);
            }
        }
        document.addEventListener('mousedown', clickOutside);
        return () => {
            document.removeEventListener('mousedown', clickOutside)
        }
// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menuRef])

    const toggleDialog = () => {
        if (disabled) return;
        store.toggleSearchDialog();
        setTimeout(() => inputRef.current?.focus(), 20);
    }

    let timeout: NodeJS.Timeout;
    const onFilterChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        clearTimeout(timeout);
        const value = event.target.value;
        const changeFilter = () => {
            store.setFilter(value);
        };
        timeout = setTimeout(changeFilter, 800);
    }

    const selectArticleWarehouse = (articleWarehouse: ArticleWarehouse) => {
        store.setSelectedArticleWarehouse(articleWarehouse);
        onChange(articleWarehouse);
    }

    const removeSelected = (e: React.MouseEvent) => {
        store.setSelectedArticleWarehouse(undefined);
        e.stopPropagation();
        onChange(undefined);
    }
    return (
        <Observer>
            {() => (
                <div className={containerClasses} ref={menuRef}>
                    <div className={classes.label}>{label || i18n.translate("ARTICLE_WAREHOUSE_SINGULAR")}</div>
                    <div className={classes.input_container} onClick={toggleDialog}>
                        <WarehouseIcon/>
                        <div className={classes.info_container}>
                            {store.selectedArticleWarehouse &&
                                <div className={classes.selected_container}>
                                    <div className={classes.selected_text_container}>
                                        <div><b>{store.selectedArticleWarehouse.name}</b></div>
                                    </div>
                                    <Tooltip title={i18n.translate("CLEAN")}>
                                        <div onClick={removeSelected} className={classes.remove_icon}><CancelIcon/>
                                        </div>
                                    </Tooltip>

                                </div>
                            }
                            {!store.selectedArticleWarehouse &&
                                <div>{i18n.translate("SELECT_ARTICLE_WAREHOUSE_PLACEHOLDER")}</div>}
                        </div>
                        <div className={classes.expand_icon}>
                            {store.isSearchDialogOpen && <ExpandLessIcon/>}
                            {!store.isSearchDialogOpen && <ExpandMoreIcon/>}
                        </div>
                    </div>
                    {store.isSearchDialogOpen &&
                        <div className={classes.options_container}>
                            <div className={classes.options_header}>
                                <input placeholder={i18n.translate("ARTICLE_WAREHOUSE_FILTER_PLACEHOLDER")} ref={inputRef}
                                       onChange={onFilterChange}/>
                            </div>
                            <div className={classes.header}>
                                <div className={classes.header_option}>
                                    <b>{`${i18n.translate("TOTAL")}:`} </b>{store.pagination.elementsCount}
                                </div>
                            </div>
                            <div className={classes.options_body}>
                                {store.loading && <Loading className={classes.loading} fontSize={55}/>}
                                {!store.loading && !store.isEmpty && <div className={classes.elements_container}>
                                    {store.elements.map((el, i) => (
                                        <ArticleWarehouseElementRow
                                            key={i}
                                            element={el}
                                            selected={el.id === store.selectedArticleWarehouse?.id}
                                            onSelect={selectArticleWarehouse}
                                        />
                                    ))}
                                </div>}
                                {!store.loading && store.isEmpty &&
                                    <div className={classes.empty_container}>
                                        <div>{i18n.translate("NO_ARTICLE_WAREHOUSES_TITLE")}</div>
                                    </div>}
                            </div>
                        </div>
                    }
                </div>
            )}
        </Observer>
    )
}


export default ArticleWarehouseSelect;
